import {toRef} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"

//響應機制的userinfo
const userInfoRef = toRef(useUserinfo())

const materialApi = {
    //分頁查詢產品
    "queryMaterialByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}material/queryMaterialByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                // identity1: null,  //商家id 已弃用
                memberid: null,
                pageNum: 1,
                pageSize: 5,
                postype: 0,
                verify: -1
            }
        }
    },
    //分頁查詢產品
    "queryMaterial": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}material/queryMaterial`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                // identity1: null,  //商家id 已弃用
                memberid: null,
            }
        }
    },
    //分頁查詢產品
    "queryMaterialAndCompanyByPageAndCompanyList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}material/queryMaterialAndCompanyByPageAndCompanyList`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                // identity1: null,  //商家id 已弃用
                memberid: null,
                companyCodeList:"",
                pageNum: 1,
                pageSize: 5,
                postype: 0,
                verify: -1
            }
        }
    },
    //刪除產品
    "takeDownMaterial": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}material/takeDownMaterial`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
            }
        }
    },
    //分頁查詢產品和對應的參展記錄和對應的公司信息
    "queryMaterialRecord15ModelByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}material/queryMaterialRecord15ModelByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                updatedid: null,  //展館id
                productname: null, //搜索關鍵字
                pageNum: 1,
                pageSize: 20
            }
        }
    },
    //分頁查詢產品和對應的參展記錄和對應的公司信息2
    "queryMaterialRecord16ModelByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}material/queryMaterialRecord16ModelByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                updatedid: null,  //展館id
                productname: null, //搜索關鍵字
                pageNum: 1,
                pageSize: 20
            }
        }
    },
    //分頁查詢產品和對應的參展記錄和對應的公司信息
    "queryMaterialAndCompanyByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}material/queryMaterialAndCompanyByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                productname: null,  //搜索关键字
                verify: -1,
                postype: 0,
                pageNum: 1,
                pageSize: 20
            }
        }
    },
    //修改產品
    "updateShopItem": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}material/updateMaterial`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,  //要修改的產品id
                bcatacode: null,
                bcatacode2: null,
                productname: null,
                productnamecn: null,
                description: null,
                description2: null,
                cost: null,
                unit: null
            }
        }
    },
    //查询展馆产品和状态
    "queryMaterialWithHallStats": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}material/queryMaterialWithHallStats`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                updatedid: null,  //展馆id
            }
        }
    },
    //查詢公司產品和分類
    "getCompanyMaterialAndType": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}material/getCompanyMaterialAndType`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
            }
        }
    },
    //刪除代理產品
    "takeDownAgentMaterial": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}material/takeDownAgentMaterial`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
            }
        }
    }
}

export default materialApi